import React, { Component } from 'react'
import tools from '@/utils/tool';
import $ from 'jquery'
// 打开app时呼起中间页
export default class index extends Component {
    constructor(props) {
        super(props)
        this.state = {
            url: '',
            download_url: ''
        }
    }
    componentDidMount() {
        this.getAndroidDownload()
        if(!this._isWeiXin()) {
            // alert('不是微信')
            // alert(window.location.href.split('url')[1].slice(1))
            // window.location = window.location.href.split('url')[1].slice(1)

            // const schema = window.location.href.split('url')[1].slice(1)
            // setTimeout(() => {
            //     try {
            //         window.location.href = schema
            //     } catch(err) {
            //         console.log(err)
            //     }
                
            //     console.log('跳转地址', schema)
            // }, 1000)
            function extractUrlParameterValue(url) {
            // 查找第一个 "url=" 的位置
            const urlIndex = url.indexOf('url=');
            
            // 如果找到了 "url="，并且后面有值，则从等号后面的第一个字符开始截取剩余的字符串
            // 否则返回null
            if (urlIndex !== -1 && urlIndex + 4 < url.length) {
                return url.substring(urlIndex + 4); // 加4是为了跳过"url="
            }
            return null;
            }
            var ken = extractUrlParameterValue(window.location.href);
            if(ken){
                setTimeout(() => {
                    try {
                        window.location.href = ken
                    } catch(err) {
                        console.log(err)
                    }
                    
                    console.log('跳转地址', ken)
                }, 1000)
            }
        }
    }
    getAndroidDownload = () => {
        const _this = this
        $.ajax({
            url: 'http://bjdcapi.bjnews.com.cn/app/new_version.php',
            timeout : 300000, //超时时间设置，单位毫秒
            type:'GET',
            async: true,
            dataType: 'json',
          }).done(resp=> {
            if(resp.code === 0) {
                _this.setState({
                    download_url: resp.data.download_url
                })
            }
          }).fail(err => {
          });
    }
    // 判断链接是不是在微信中打开
    _isWeiXin = () => {
        return /micromessenger/.test(navigator.userAgent.toLowerCase());
    };
    // 唤起app的微信流程,微信中无法直接呼起app，安卓需要通过应用宝流程
    openAppInWeixin =(iosUrl,androidUrl)=> {
        // alert(`渲染微信${window.location.href} `)
        const wxBrowser = <div className='wxBrowserContainer'>
                            <div className="content">
                                <div className="header">
                                <div className="hintText">已安装北京东城客户端</div>
                                <div className="handle">
                                    点击<span className='hintIcon'></span>
                                    使用浏览器<span className='browserIcon'></span>打开
                                </div>
                                </div>
                                <div className="pointer">
                                </div>
                                <div className="download">
                                <div className="downloadBtn" onClick={this.weiXinBtn}></div>
                                </div>
                            </div>
                            </div>
        return wxBrowser
    };
    weiXinBtn = () => {
        var ios_app_url = 'https://apps.apple.com/cn/app/%E5%8C%97%E4%BA%AC%E4%B8%9C%E5%9F%8E/id1459595192'
        var userAgent = this.userAgent()
        if(userAgent === 0) {
        window.open(ios_app_url)
        } else {
        alert('点击右上角按钮，然后在弹出的菜单中，点击浏览器中打开，即可安装')
        console.log('Android')
        }
    } 
    // 判断是安卓还是苹果
    userAgent = () => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return 0;
        } else if (/(Android)/i.test(navigator.userAgent)) {
        return 1;
        }
    };
    render() {
        const {download_url} = this.state
        // var download_url = 'https://bj-dongcheng.oss-cn-beijing.aliyuncs.com/package/2020/12/16/5003313083700028486.apk'
        var ios_app_url = 'https://apps.apple.com/cn/app/%E5%8C%97%E4%BA%AC%E4%B8%9C%E5%9F%8E/id1459595192'
        // var ios_download_url = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
        // var ios_url = 'com.foundaoDongCheng://'
        // var android_url = 'com.foundao.dongcheng://bjnews.com/action?'
        // const iosUrl = ios_url + name + '/' + uuid
        // const androidUrl = android_url + 'name=' + name + '&uuid=' + uuid
        const iosUrl = this.props.location.search.split('=')[1]
        const androidUrl = this.props.location.search.split('=')[1]
        return (
            this._isWeiXin() ? this.openAppInWeixin(iosUrl, androidUrl) : 
            this.userAgent() === 0 ?
                <div className='browserContainer' onClick={this.test}>
                    <div className="content">
                    <div className="logoBox"><div></div></div>
                    <div className="title">北京东城客户端</div>
                    <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
                    <div className="download">
                        <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = ios_app_url}}></div>
                    </div>
                    </div>
                </div> :
                <div className='browserContainer' onClick={this.test}>
                    <div className="content">
                    <div className="logoBox"><div></div></div>
                    <div className="title">北京东城客户端</div>
                    <div className="subTitle"><span>聚焦东城</span><span>智慧便民</span></div>
                    <div className="download">
                        <div className="downloadBtn inBrowserBtn" onClick={() => {window.location.href = download_url}}></div>
                    </div>
                    </div>
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/Detail/MiddlePage/index.js